import React from "react";
import NoFoundImg from "../../../../assets/profile/resultNotFound.png";
import { useTranslation } from "react-i18next";

export const NoAffiliatesFound = () => {
  const { t } = useTranslation(["profile"]);

  return (
    <div className="no-affiliates-found-wrapper">
      <div className="no-affiliates-found">
        <img src={NoFoundImg} />
        <div className="no-affiliates-found-title">
          {t("noAffiliatesFound")}
        </div>
        <div className="no-affiliates-found-desc">{t("noAffiliatesFoundDesc")}</div>
      </div>
    </div>
  );
};
